import 'bootstrap/dist/css/bootstrap.css'
import { createApp } from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
// import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
// import certain than all from regular, use format: <fa :icon="['far', 'circle']" size="lg" />
// import { far } from '@fortawesome/free-regular-svg-icons'
import { faCircle, faCircleXmark } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './assets/font-awesome-animation.min.css'

import App from './App.vue'
import './registerServiceWorker'
import router from './router'

import i18n from './locales/i18n'
// import i18n from './i18n'

import './assets/global.css'
// library.add(fas, fab, far)
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

library.add(
//   ...(Object.values(fas) as IconDefinition[]),
  ...(Object.values(fab) as IconDefinition[]), 
  faCircle as IconDefinition,
  faCircleXmark as IconDefinition
  // ...(Object.values(far) as IconDefinition[])
)

import axios from '@/functions/axios-instance'    

import { initStore } from '@/stores/store'
const store = initStore()

/* import { useStore } from '@/stores/store'
const store = useStore() */


createApp(App)
    .provide('axios', axios)
    .provide('store', store)
    .use(i18n)
    .use(router)
    .component('fa', FontAwesomeIcon)
    .mount('#app') 

import 'bootstrap/dist/js/bootstrap.js'
// cannot use bootstrap.bundle.js as block profile dropdown and conflict with tooltips
// import 'bootstrap/dist/js/bootstrap.bundle.js'

// console.info('Hydration Flag:', __VUE_PROD_HYDRATION_MISMATCH_DETAILS__)

// vuejs 3 + typescript + router + babel
// -------------------------------------
// npm i axios
// npm i bootstrap
// npm i popperjs@/core - Not working in v-for
// npm i --save @fortawesome/vue-fontawesome@prerelease
// npm i --save @fortawesome/fontawesome-svg-core
// npm i --save @fortawesome/free-solid-svg-icons
// npm i --save @fortawesome/free-brands-svg-icons
// npm i --save @fortawesome/free-regular-svg-icons
// sudo 
// npm uninstall @fortawesome/xxx one by one > npm install > npm reinstall back one by one when upgrade having issues

// npm i vue3-draggable-resizable
// npm i vue-pdf-embed
// npm i pdf-lib
// npm i downloadjs
// [deprecated]npm i vue3-date-time-picker 
// ---- Replaced with npm i --save @vuepic/vue-datepicker@5.0.0 | https://v5.vue3datepicker.com/installation/
// npm i vue3-popper

// npm i vue-filepond filepond --save
// npm i filepond-plugin-file-validate-type --save
// npm i filepond-plugin-image-preview --save

// npm i vue-i18n@next
// npm i --save vue-drawing-canvas

// npm i pdfvuer@next --save (replace vue-pdf-embed due to blur when scale)

// npm i free-email-domains

// npm i papaparse
// npm i @types/papaparse

// npm i js-cookie
// npm i @types/js-cookie

// npm i modern-screenshot --save
// npm i file-saver

// npm i qrcode-vue3